import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { SubjectIcon } from "@/components/SubjectIcon";
import { remap } from "@/lib/palette";
import { ArrowLeft, GraduationCap, Books, CheckCircle, Robot } from "@phosphor-icons/react";

export default function FiliereDetail() {
  const { filiereId } = useParams();
  const navigate = useNavigate();
  const [f, setF] = useState(null);

  useEffect(() => {
    api.get(`/filieres/${filiereId}`).then((r) => setF(r.data)).catch(() => navigate("/app/filieres"));
  }, [filiereId, navigate]);

  if (!f) return <div className="h-64 animate-pulse rounded-2xl bg-sand" />;

  return (
    <div className="space-y-8">
      <Link to="/app/filieres" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-terracotta"><ArrowLeft /> Toutes les filières</Link>

      <div className="flex items-center gap-4 animate-fade-up">
        <div className="grid h-14 w-14 place-items-center rounded-2xl" style={{ background: `${remap(f.color)}1a`, color: remap(f.color) }}>
          <SubjectIcon name={f.icon} size={30} />
        </div>
        <div>
          <h1 className="font-display text-3xl font-extrabold">{f.name}</h1>
          <p className="text-muted-foreground">Filière technique & professionnelle</p>
        </div>
      </div>

      <div className="grid gap-6 lg:grid-cols-3">
        <div className="rounded-2xl border border-border bg-white p-6">
          <h2 className="font-display text-lg font-bold">Séries</h2>
          <div className="mt-3 space-y-2">
            {f.series.map((s) => (
              <div key={s.code} className="flex items-center gap-3 rounded-xl bg-cream px-4 py-2.5">
                <span className="rounded-lg bg-terracotta px-2 py-0.5 text-xs font-bold text-white">{s.code}</span>
                <span className="text-sm font-medium">{s.name}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="rounded-2xl border border-border bg-white p-6">
          <h2 className="font-display text-lg font-bold">Classes</h2>
          <div className="mt-3 flex flex-wrap gap-2">
            {f.classes.map((c) => (
              <span key={c} className="inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-1.5 text-sm">
                <GraduationCap size={15} className="text-forest" /> {c}
              </span>
            ))}
          </div>
        </div>
        <div className="rounded-2xl border border-border bg-white p-6">
          <h2 className="font-display text-lg font-bold">Examens</h2>
          <div className="mt-3 space-y-2">
            {f.exams.map((e) => (
              <div key={e} className="flex items-center gap-2 text-sm"><CheckCircle weight="fill" className="text-forest" size={16} /> {e}</div>
            ))}
          </div>
        </div>
      </div>

      <div className="rounded-2xl border border-border bg-white p-6">
        <div className="flex items-center gap-2"><Books weight="fill" className="text-terracotta" size={22} /><h2 className="font-display text-lg font-bold">Matières professionnelles</h2></div>
        <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {f.subjects.map((s) => (
            <div key={s} data-testid={`fil-subject-${s}`} className="rounded-xl border border-border bg-cream px-4 py-3 text-sm font-medium">{s}</div>
          ))}
        </div>
        <Link to="/app/tuteur" className="mt-5 inline-flex items-center gap-2 rounded-full bg-forest px-5 py-2.5 text-sm font-semibold text-white hover:bg-forest/90">
          <Robot weight="fill" /> Réviser avec le Professeur IA orienté {f.name}
        </Link>
      </div>
    </div>
  );
}
